import { VisitDiagnosisNotFoundFault, VisitNotInUpdatableStatusFault } from '@dreryk/egabinet-visit-frontend-api';

import { dispatchSnackbarNegativeEvent, useInteractiveTableContext } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../../../translations';
import { DiagnosisTableBean } from '../../../DiagnosesFormTab.types';

export type VisitDiagnosisCommonFault = VisitNotInUpdatableStatusFault | VisitDiagnosisNotFoundFault;

type VisitDiagnosisFaultHandlerMap = {
   [F in VisitDiagnosisCommonFault as F['class']]: (fault: F) => void;
};

export const useVisitDiagnosisFaultHandlerMap = (): VisitDiagnosisFaultHandlerMap => {
   const { removeRow, getValues } = useInteractiveTableContext<DiagnosisTableBean>();

   return {
      'egabinet-visit-frontend-api:VisitNotInUpdatableStatusFault': () => {
         dispatchSnackbarNegativeEvent(
            visitDetailsTranslationKeys.diagnoses.interceptors.shared.faultHandlerMap.visitNotInUpdatableStatus
         );
      },
      'egabinet-visit-frontend-api:VisitDiagnosisNotFoundFault': ({ code }) => {
         const indexToRemove = getValues().findIndex((diagnosis) => diagnosis.code === code.asString());
         if (indexToRemove !== -1) {
            removeRow(indexToRemove);
         }
      },
   } as const;
};
